import { h, Component } from 'preact';
import style from './style';

import Back from '../../../components/back';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

import { route } from 'preact-router';

import { apiGetRequest } from '../../../components/utils/api';
import Header from '../../../components/header';


export default class TeamMembers extends Component {
	constructor(props) {
        super(props);
        this.state = {
            team: {},
            loading: true
        }
    }

    getTeamDetails() {
        apiGetRequest("teams/get-details/?team=" + this.props.team.url_identifier).then((data) => {
            console.log(data);
            this.setState({team: data, loading: false})
        }).catch((error) => {
            console.log(error);
            this.props.changeAppLoading(false);
        })
    }

    componentDidMount() {
        this.getTeamDetails();
    }

	render() {
        if (this.state.loading) {

        } else {
            return (
                <div class={cx("home")}>
                    <Header />
    
                    <div class={cx("content")}>
                        <Back 
                            cta={"Back to Management"}
                            callback={() => {
                                route("/team/management/")
                            }}
                        />
                        <h2>{this.props.team.team_name} Members 👨‍👩‍👧‍👦</h2>
                        <div class={cx("button-container")}>
                            <button class={cx("button-base", "button-success")} onClick={() => route("/team/management/members/invite/")}>
                                <p>Invite People</p>
                            </button>
                        </div>
                        
                        <div class={cx("member-table")}>
                            <div class={cx("titles")}>
                                <div>
                                    <p>Name</p>
                                </div>
                                <div>
                                    <p>Email</p>
                                </div>
                                <div>
                                    <p>Role</p>
                                </div>
                            </div>
                            {this.state.team.members.map((item) => (
                                <div class={cx("member")}>
                                    <div>
                                        <p>{item.user_name}</p>
                                    </div>
                                    <div>
                                        <p>{item.user_email}</p>
                                    </div>
                                    <div>
                                        <p>{item.role}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );
        };
	}
}




// WEBPACK FOOTER //
// ./routes/teams/members/index.js